import React, {useState, useEffect} from 'react';
import {colorPalette} from '../../../config';
import {Container, HiddenRadio, Label} from './style';
import {BsCheckLg} from 'react-icons/bs';
import {getInfo} from '../../../api/admin';
import {getParticipationCount} from '../../../api/index';

const Radio = ({
	children,
	border,
	name,
	color,
	onChange,
	checked,
	value,
	Icon,
	isDisabled,
	isDefault,
}) => {
	const [info, setInfo] = useState({
		id: 0,
		name: '',
		started: '',
		ended: '',
		volunteer_ended: '',
		// full_num: 0,
		half_num: 0,
		ten_num: 0,
		five_num: 0,
	});
	const [pCount, setPCount] = useState({
		// full: 0,
		half: 0,
		ten: 0,
		five: 0,
	});
	let fakeProps = {
		target: {
			name,
			value,
		},
	};
	// const COURSE_VALUES = new Set(['풀코스', '하프코스', '10km코스', '5km코스']);
	const COURSE_VALUES = new Set(['하프코스', '10km코스']);
	useEffect(() => {
		(async () => {
			const [res_count, res] = await Promise.all([getParticipationCount(), getInfo()]);
			if (!res.isSuccess || res.data.count !== 1) {
				return alert(
					'현재 정보가 잘못 설정되었습니다. 사무국으로 문의해주세요',
				);
			}

			setPCount(res_count.data.counts);
			setInfo(res.data.results[0]);
		})();
	}, []);
	const capacityAvailable = (() => {
		const limitMap = {
			// '풀코스': info.full_num,
			'하프코스': info.half_num,
			'10km코스': info.ten_num,
			// '5km코스': info.five_num,
		};
		const countMap = {
			// '풀코스': pCount.full,
			'하프코스': pCount.half,
			'10km코스': pCount.ten,
			// '5km코스': pCount.five,
		};
		const limit = limitMap[value] ?? 0;
		const count = countMap[value] ?? 0;
		return count < limit;
	})();
	const baseDisabled = COURSE_VALUES.has(value);
	const computedDisabled = value === '2026-04-11' || (isDefault
		? false
		: (isDisabled ? true : (baseDisabled ? !capacityAvailable : false)));
	return (
		<Container
			onClick={(e) => {
				if (!computedDisabled) {
					onChange(fakeProps);
				}
			}}
			isDisabled={computedDisabled}
			checked={checked}
			border={border}
		>
			<HiddenRadio
				name={name}
				value={value}
				type='radio'
				onChange={(e) => onChange(e)}
				checked={checked}
				disabled={computedDisabled}
			/>
			<Label name={name}>{children}</Label>
			<BsCheckLg
				style={{margin: 'auto 1rem auto auto'}}
				color={
					checked ? colorPalette.primary : colorPalette.placeholder
				}
			/>
		</Container>
	);
};

export default Radio;
